import { render, staticRenderFns } from "./vfg-vscurrency.vue?vue&type=template&id=0861023f"
import script from "./vfg-vscurrency.vue?vue&type=script&lang=js"
export * from "./vfg-vscurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports